import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "overlay", "panel", "openIcon", "closeIcon"]
  static values = { open: Boolean }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.render()
  }

  close(event) {
    event?.preventDefault()
    if (!this.openValue) return

    this.openValue = false
    this.render()
  }

  openValueChanged() {
    this.render()
  }

  render() {
    const isOpen = this.openValue

    this.element.dataset.open = String(isOpen)
    this.buttonTarget.setAttribute("aria-expanded", String(isOpen))
    this.buttonTarget.setAttribute("aria-label", isOpen ? "Close navigation menu" : "Open navigation menu")
    this.openIconTarget.hidden = isOpen
    this.closeIconTarget.hidden = !isOpen
    this.overlayTarget.hidden = !isOpen
  }
}
